<template>
    <div class="component-groups">

        <header class="page-header page-header--inverted groups-header">
            <h1>{{ salutation }}</h1>
            <p v-if="!isActive">Deze school is gearchiveerd.</p>
            <p v-else-if="groups.length">Kies een klas om te beginnen</p>
            <p v-else>Voeg een klas toe om te beginnen.</p>
        </header>

        <div class="groups-content">

            <loading v-if="loading"></loading>

            <transition-group name="insertion-bottom" appear tag="ol" class="teacher-groups" v-if="groups.length" >
                <li class="teacher-groups__item" v-for="group in groups" :key="group.id" >
                    <span class="group-message note note--warning" v-if="isFinished(group)"><strong>Let op:</strong> Deze klas is klaar. Na {{ archiveAt(group) }} kunt u de werkmappen niet meer inzien.</span>
                    <a href="#" @click.prevent="showGroupSettings(group)" class="button--settings">Instellingen</a>
                    <h2>{{ group.name }}</h2>
                    <primary-button :link="{ name: 'students.overview', params: { groupId: group.id } }" >Bekijk</primary-button>
                </li>
            </transition-group>

            <a href="#" @click.prevent="showSchoolGroups" v-if="isActive" class="button-rounded button-add button-add-group" ><span class="icon icon--add"></span>Klas toevoegen</a>

        </div>

    </div>
</template>


<script>

import { getCurrentGroupPeriodIdForGroup } from 'js/vuex/getters'
import { transform, logreject } from 'js/vuex/helpers'
import api from  'js/api/resources'
import notify from 'js/components/notifications/notificationsMixin'
import track from 'js/helpers/analytics'
import moment from 'js/helpers/moment'

import PrimaryButton from 'js/components/elements/PrimaryButton.vue'
import Loading from 'js/components/elements/Loading.vue'

export default {
    name: 'Groups',
    mixins: [ notify ],
    components: { PrimaryButton, Loading },

    data: function() {
        return {
            loading: false,
        }
    },

    vuex: {
        getters: {
            getCurrentGroupPeriodIdForGroup,
            groups: state => state.users.current.groups.map( id => state.groups.storage[id] ).sort( (a,b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                // names must be equal
                return 0;
            }),

            school: state => state.users.current.schools.map( id => state.schools.storage[id] )[0]
        },
        actions: {

            showSchoolGroups: ({ dispatch }) => {

                dispatch('SHOW_MODAL', 'schoolGroups')

            },

            fetchGroupsForTeacher: ({dispatch}, id) => {

                return api.getGroupsForTeacher(id)
                    .then( response => {

                        let result = transform(response.body)
                        let groups = result.groups || []

                        dispatch('ADD_GROUPS', groups);
                        dispatch('SET_CURRENT_USER_GROUPS', groups.map( g => g.id) )

                        return groups

                    })
                    .catch(error => logreject('Could not fetch groups', error))

            },

            showGroupSettings: ({dispatch}, group) => {
                dispatch('SHOW_MODAL', 'GroupSettings', { group: group })
            }


        }
    },

    computed: {

        salutation: function() {
            const d = new Date()
            const h = d.getHours()

            if ( h < 12 ) return 'Goedemorgen'
            if ( h < 18 ) return 'Goedemiddag'
            if ( h < 24 ) return 'Goedenavond'
        },


        isActive: function() {
            return this.school && !this.school.archived
        }

    },

    methods: {

        isFinished: function(group) {
            return !group.archived && group.finished
        },

        archiveAt: function(group) {
            const date = moment(group.archive_at * 1000)
            return date.format('D MMMM') + ' (' + date.fromNow() + ')'
        },

    },

    created: function() {

        if ( this.groups.some( g => g == null ) ) {

            this.loading = true

            this.fetchGroupsForTeacher( this.$store.state.users.current.id )
                .then( () => this.loading = false )
                .catch( err => {
                    track.exception('Can\'t load groups', err)
                    this.$error('Kan klassen niet laden.')
                })

        }


    }
}
</script>


<style lang="scss">

    @import 'global';

    .page-header--inverted {
        color: $color-typography-inverted;
    }

    .teacher-groups {
        list-style-type: none;
        margin: 2em;
        padding: 0;
        @media #{$media-mobile} {
            margin: 2em 0;
        }
    }

    .teacher-groups__item {

        display: block;
        margin: 2em auto;
        padding: 2em;
        max-width: 400px;
        border-radius: 4px;

        background-color: $color-white;

        text-align: center;
        overflow: hidden; // makes sure rounded corners are applied to children

        h2 {
            color: $color-primary;
            font-size: 3.5em;
        }

    }

    .group-message {
        $multiplier: 1/0.833;// font size is changed, so invert the relative size for the margin
        margin: $multiplier*-2em $multiplier*-2em $multiplier*1.5em;
        border-radius: 0;
    }

    .groups-content {
        text-align: center;
    }

    .page-header.groups-header {
        padding-top: 2em;
    }

    .button-add-group {
        margin: 2em;
    }

    .button--settings {
        @include background-sprite-replace($icon-settings-grey-group);

        &:hover {
            @include sprite-position($icon-settings-primary);
        }
    }

</style>



// WEBPACK FOOTER //
// Groups.vue?dea26be8